import { SubscriptionDurationTypesEnum } from "../models/Subscription";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

export const getSubscriptionDurationType = (
  durationType: SubscriptionDurationTypesEnum,
  duration: number,
  t: TFunction
) => {
  switch (durationType) {
    case SubscriptionDurationTypesEnum.day:
      if (duration > 1) return t("Days");
      return t("Day");
    case SubscriptionDurationTypesEnum.week:
      if (duration > 1) return t("Weeks");
      return t("Week");
    case SubscriptionDurationTypesEnum.month:
      if (duration > 1) return t("Months");
      return t("Month");
    case SubscriptionDurationTypesEnum.year:
      if (duration > 1) return t("Years");
      return t("Year");
  }
};
